import {Component} from '@angular/core';

@Component({
  selector: 'progress-spinner-dialog',
  templateUrl: './progress-spinner-dialog.component.html',
  styleUrls: ['./progress-spinner-dialog.component.css'],
})
export class ProgressSpinnerDialog {

  public progress: number;

}
